/*! @azure/msal-browser v4.21.1 2025-08-27 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-browser";
const version = "4.21.1";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
